import { __rest } from '../../node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';
import { isBrowser, localizeItem } from '@websolutespa/bom-core';
import { LayoutProvider, LabelProvider, PageProvider, ExtraProvider } from '@websolutespa/bom-mixer-hooks';
import { useRef, useMemo, useEffect } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { LlmComponent } from '../../llm/llm.js';
import { LlmProvider } from '../../useLlm/useLlm.js';
import { ErrorHandler } from './error-handler.js';
import defaultLabels from './label.json.js';

const App = _a => {
  var {
      locale,
      market,
      instance
    } = _a,
    props = __rest(_a, ["locale", "market", "instance"]);
  const llmRef = useRef(null);
  const data = useMemo(() => {
    if (isBrowser) {
      const htmlLang = getHtmlLang();
      const title = document.querySelector('title');
      const description = document.querySelector('meta[name="description"]');
      const canonical = document.querySelector('link[rel="canonical"]');
      return {
        locale: locale || (htmlLang === null || htmlLang === void 0 ? void 0 : htmlLang.locale) || 'it',
        market: market || (htmlLang === null || htmlLang === void 0 ? void 0 : htmlLang.market) || 'ww',
        origin: window.origin,
        canonical: (canonical === null || canonical === void 0 ? void 0 : canonical.getAttribute('href')) || window.location.href,
        title: title ? title.innerText : 'Untitled',
        description: (description === null || description === void 0 ? void 0 : description.getAttribute('content')) || '',
        slug: window.location.pathname
      };
    } else {
      return {
        locale: locale || 'it',
        market: market || 'ww',
        origin: '',
        canonical: '',
        title: 'Untitled',
        description: '',
        slug: ''
      };
    }
  }, [locale, market]);
  const defaultEndpoint = typeof props.test !== 'undefined' ? 'https://bom-sample-basic-web-git-bom-llm-actarian.vercel.app' : 'https://platform.websolute.ai';
  const endpoint = props.endpoint || defaultEndpoint;
  const layout = {
    labels: getLabels(data.locale, defaultLabels, props.labels),
    locale: data.locale,
    locales: [{
      id: data.locale,
      title: data.locale
    }],
    market: data.market,
    markets: [{
      id: data.market,
      title: data.market
    }],
    menu: {},
    topLevelHrefs: {},
    topLevelRoutes: {}
  };
  const page = {
    locale: data.locale,
    market: data.market,
    title: data.title,
    abstract: data.description,
    category: {
      id: 'homepage',
      title: 'Homepage',
      slug: '',
      href: '/'
    },
    schema: 'homepage',
    slug: data.slug,
    href: data.canonical,
    id: 1,
    alternates: [],
    breadcrumb: [],
    canonical: data.canonical
  };
  const extra = {};
  useEffect(() => {
    if (llmRef.current && instance) {
      // console.log('App', llmRef.current, instance);
      Object.assign(instance, llmRef.current);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return jsx(ErrorBoundary, {
    FallbackComponent: ErrorHandler,
    children: jsx(LayoutProvider, {
      layout: layout,
      children: jsx(LabelProvider, {
        children: jsx(PageProvider, {
          page: page,
          children: jsx(ExtraProvider, {
            extra: extra,
            children: jsx(LlmProvider, Object.assign({}, props, {
              endpoint: endpoint,
              children: jsx(LlmComponent, {
                ref: llmRef
              })
            }))
          })
        })
      })
    })
  });
};
function getLabels(locale, defaultLabels, extendedLabels) {
  if (extendedLabels === void 0) {
    extendedLabels = [];
  }
  const labels = [...defaultLabels.filter(x => extendedLabels.findIndex(e => e.id === x.id) === -1), ...extendedLabels];
  return labels.map(x => {
    const localizedItem = localizeItem(x, locale, 'en');
    return {
      id: localizedItem.id,
      schema: 'label',
      text: localizedItem.text
    };
  });
}
function getHtmlLang() {
  const html = document.querySelector('html');
  const htmlLang = html === null || html === void 0 ? void 0 : html.getAttribute('lang');
  if (htmlLang) {
    const segments = htmlLang.toLowerCase().split('-');
    return {
      locale: segments[0],
      market: segments[1] || 'ww'
    };
  } else {
    return undefined;
  }
}

export { App };
//# sourceMappingURL=app.js.map
